"use strict";

module.exports = function (a, b, reserved) {
  // This will get id, className, style, etc.
  for (var x in b) {
    if (!b.hasOwnProperty(x)) continue;
    if (reserved[x]) continue;
    a[x] = b[x];
  }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-aria-menubutton/dist/specialAssign.js
// module id = 146
// module chunks = 0